export default {
  home: {
    id: 'seller-permissions-home',
    defaultMessage: 'Home',
  },
  insights: {
    id: 'seller-permissions-insights',
    defaultMessage: 'Insights',
  },
  customerCare: {
    id: 'seller-permissions-customer_care',
    defaultMessage: 'Customer Care',
  },
  listings: {
    id: 'seller-permissions-listings',
    defaultMessage: 'Listings',
  },
  orders: {
    id: 'seller-permissions-orders',
    defaultMessage: 'Orders',
  },
  opportunities: {
    id: 'seller-permissions-opportunities',
    defaultMessage: 'Opportunities',
  },
  invoices: {
    id: 'seller-permissions-invoices',
    defaultMessage: 'Invoices',
  },
  options: {
    id: 'seller-permissions-options',
    defaultMessage: 'Options',
  },
  reviews: {
    id: 'seller-permissions-reviews',
    defaultMessage: 'Reviews',
  },
  customerReviews: {
    id: 'seller-permissions-customer-reviews',
    defaultMessage: 'Customers reviews',
  },
  profile: {
    id: 'seller-permissions-profile',
    defaultMessage: 'Profile',
  },
  fileLibrary: {
    id: 'seller-permissions-file_library',
    defaultMessage: 'File Library',
  },
}
